import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=d2622594&"
import script from "./Budget.vue?vue&type=script&lang=js&"
export * from "./Budget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports